import styled, { css } from 'styled-components'

import { deviceMax } from '../../theme/breakpoints'
import { ExternalLink, InternalLink } from '../Link/Link'
import pxToRem from '../../utils/pxToRem'

export const StyledFooter = styled.footer`
  margin-top: ${pxToRem(30)};
`

export const StyledBottomFooter = styled.nav`
  align-items: center;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  justify-content: center;
  display: flex;
  padding: ${pxToRem(18)};
  background-color: ${({ theme }) => theme.colors.unique.white};
  @media ${deviceMax.laptop} {
    flex-direction: column;
    padding: ${pxToRem(19)};
  }
`

export const FooterCopyright = styled.p`
  margin-right: ${({ $light }) => ($light ? 0 : pxToRem(50))};
  font-size: ${({ theme }) => theme.fonts.sizes.xs};
  line-height: ${pxToRem(14)};
  text-align: center;
  @media ${deviceMax.laptop} {
    margin-right: inherit;
    margin-top: ${({ $light }) => ($light ? 0 : pxToRem(10))};
  }
  @media ${deviceMax.mobileL} {
    margin: inherit;
  }
`

export const FooterList = styled.ul`
  flex-wrap: wrap;
  justify-content: center;
  display: flex;
  @media ${deviceMax.mobileL} {
    align-items: center;
    flex-direction: column;
  }
`

export const FooterLi = styled.li`
  align-items: center;
  display: flex;
  @media ${deviceMax.laptop} {
    margin: 0 0 ${pxToRem(10)} 0;
  }
  @media ${deviceMax.mobileL} {
    flex-direction: column;
    margin: 0;
  }
`

export const Separator = styled.div`
  margin: 0 ${pxToRem(10)};
  border-radius: ${pxToRem(1)};
  width: ${pxToRem(1)};
  height: ${pxToRem(10)};
  background-color: ${({ theme }) => theme.colors.primary.blue};
  @media ${deviceMax.mobileL} {
    display: block;
    margin: ${pxToRem(10)} 0;
    width: ${pxToRem(10)};
    height: ${pxToRem(1)};
  }
`

const StyledLink = css`
  padding: 0;
  font-size: ${({ theme }) => theme.fonts.sizes.xs};
  line-height: ${pxToRem(14)};
  text-align: center;
  text-decoration: none;
`

export const FooterInternalLink = styled(InternalLink)`
  ${StyledLink}
`

export const FooterExternalLink = styled(ExternalLink)`
  ${StyledLink}
`
